import React, { Component } from 'react'
import { Container, Table, Button, Spinner } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers';
import axios from 'axios'
import { convertRiceTypeENToTH, addCommaInNumber } from '../../helpers/function'
import CheckWeight from './CheckWeight';
function convertDate(inputDate) {
  let date = new Date(inputDate)
  let days = date.getDate()
  if (parseInt(days) < 10) {
    days = `0${days}`
  }
  let month = parseInt(date.getMonth()) + 1
  if (parseInt(month) < 10) {
    month = `0${month}`
  }
  let year = date.getFullYear()
  let outputDate = `${year}-${month}-${days}`
  return outputDate
}
function timeInterval(startDate, endDate) {
  var now = new Date(startDate);
  var then = new Date(endDate);
  var dayCount = 0;
  let dateArr = []
  dateArr.push(convertDate(startDate))
  while (now.setHours(1, 3, 3, 7) > then.setHours(1, 3, 3, 7)) {
    let newThen = then.setDate(then.getDate() + 1);
    dateArr.push(convertDate(newThen))
    dayCount++;
  }
  while (now.setHours(1, 3, 3, 7) < then.setHours(1, 3, 3, 7)) {
    let newNow = now.setDate(now.getDate() + 1);
    dateArr.push(convertDate(newNow))
    dayCount++;
  }
  var years = Math.floor(dayCount / 365);
  dayCount = dayCount - years * 365;
  var months = Math.floor(dayCount / 30);
  dayCount = dayCount - months * 30;
  var days = dayCount

  return dateArr
}

class FinancialWageMonthlyTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listInComplete: false,
      inCompleteLoading: true,
      completedLoading: false,
      CompanyList: [],
      riceTypeIDAndName: [],
      data: [],
      sumData: {},
      officerDataSecondPart : [],
      officerDataFirstPart : []
    }
    this.handleTableClick = this.handleTableClick.bind(this)
    this.searchJob = this.searchJob.bind(this)
  }
  queryJobID = (jobIDArr) => {
    // console.log(jobIDArr)
    return axios.post(
      'https://backend1.riceinspections.com/testHB',
      {
        data: { 'arr': [...new Set(jobIDArr)] },
      })
  }
  // 
  queryRequestID = (requestIDArr) => {
    // console.log(jobID)
    return axios.post(
      'https://backend1.riceinspections.com/testHC',
      {
        data: { 'arr': [...new Set(requestIDArr)] },
      })
  }
  reConstructRequestID = (requestID) => {
    let newRequestID = []
    if (Array.isArray(requestID)) {
      requestID.map((data) => {
        newRequestID.push(Object.values(data)[0])
      })
    }
    return newRequestID
  }

  calculateWage(start, end) {
    if (start && end) {
      // console.log(start,end)
      let firstPartStart = start.split('.')[0]
      let secondPartStart = start.split('.')[1]
      if (firstPartStart.length != 2) {
        firstPartStart = `0${firstPartStart}`
        start = `${firstPartStart}.${secondPartStart}`
      }
      if (start.length == 5 && end.length == 5) {
        let holiday = false
        let startHrInMin = (parseInt(start.slice(0, 2)) * 60)
        let startMinInMin = (parseInt(start.slice(start.length - 2, start.length)))
        let startMin = startHrInMin + startMinInMin
        let endMin = (parseInt(end.slice(0, 2)) * 60) + (parseInt(end.slice(end.length - 2, end.length)))
        // let total = Math.ceil((endMin - startMin)/60) * 0
        let total = 1
        if (holiday) {
          if (parseInt(start.slice(0, 2)) <= 7) {
            total += 1
          }
          if (parseInt(start.slice(0, 2)) <= 7 && parseInt(end.slice(0, 2)) < 18) {
            total += 1
          }
          if (parseInt(start.slice(0, 2)) >= 8 && parseInt(end.slice(0, 2)) < 18) {
            total += 1
          }
          if (parseInt(start.slice(0, 2)) >= 8 && parseInt(end.slice(0, 2)) >= 18) {
            total += 1
          }
          if (parseInt(end.slice(0, 2)) >= 18) {
            total += 1
          }
          if (parseInt(start.slice(0, 2)) <= 7 && parseInt(end.slice(0, 2)) >= 18) {
            total += 1
          }
        } else {
          if (parseInt(start.slice(0, 2)) <= 7) {
            total += 1
          }
          if (parseInt(end.slice(0, 2)) >= 18) {
            total += 1
          }
        }
        // console.log(total)
        return total
        // total += parseFloat(this.state.paidWageSheet.Extra)
        // Object.keys(this.state.FinancialSheet.description.description).map((title)=>{
        //   if(Number.isInteger(parseInt(title))){
        //     total += (parseFloat(this.state.FinancialSheet.description.description[title]['quantity'])*2.5)
        //   }
        // })
        // total = total.toFixed(2)
      }
    }

  }

  componentDidMount() {
    // let viewAllFinancialWageByDate = axios.post(
    //   'https://backend1.riceinspections.com/testHA',
    //   {
    //     data: { 'timeValue': this.props.history.location.state },
    //   }
    // )


    // console.log(this.props.history.location.state)
    let startDate = this.props.history.location.state.startDate
    let endDate = this.props.history.location.state.endDate
    console.log(this.props.history.location.state)

    if (!endDate) {
      endDate = startDate
    }
    let dateArr = timeInterval(convertDate(startDate), convertDate(endDate))
    dateArr = [...new Set(dateArr)]

    let viewAllWageSheetByDate = axios.post(
      'https://backend1.riceinspections.com/testIB',
      {
        data: { 'arr': dateArr },
      }
    )

    let viewAllOfficer = axios.get(
      'https://backend1.riceinspections.com/testC',
    )
    let viewAllFinancialWageByDate = []
    dateArr.map((dateSingle) => {
      let newPromise = axios.post(
        'https://backend1.riceinspections.com/testHA',
        {
          data: { 'timeValue': dateSingle },
        }
      ).then((res) => {
        return res['data']
      })
      viewAllFinancialWageByDate.push(newPromise)
    })
    Promise.all(viewAllFinancialWageByDate,)
      .then((res) => {
        console.log(res)
        // let middleDate = 0
        let officerDataFirstPart = {}
        let officerDataSecondPart = {}
        // res.map((financialData,idx)=>{
        //   if(financialData[0]['shippingDate'] == `${endDate.split('-')[0]}-${endDate.split('-')[1]}-01`){
        //     middleDate = idx 
        //   }
        // })

        let jobIDArr = []
        let requestIDArr = []
        let checkWeight = {}

        let newRes = []
        res.map((resSec) => {
          newRes.push(...resSec)
        })

        newRes.map((checkWeightData, idx) => {
          jobIDArr.push(checkWeightData['requestID'])
          requestIDArr.push(checkWeightData['requestID'])
          checkWeight = {
            ...checkWeight,
            [checkWeightData['requestID']]: {
              ...CheckWeight[checkWeightData['requestID']],
              ...checkWeightData,
              quantity: (() => {
                if (checkWeight[checkWeightData['requestID']]?.quantity > 0) {
                  return parseFloat(checkWeight[checkWeightData['requestID']]?.quantity) + parseFloat(checkWeightData['quantity'])
                }
                else {
                  return checkWeightData['quantity']
                }
              })()
            }
          }
        })

        Promise.all([this.queryJobID(jobIDArr), this.queryRequestID(requestIDArr), viewAllOfficer, viewAllWageSheetByDate]).then((resSec) => {
          let jobID = resSec[0]['data']
          let requestID = resSec[1]['data']
          viewAllOfficer = resSec[2]['data']
          viewAllWageSheetByDate = resSec[3]['data']
          requestID = this.reConstructRequestID(requestID)
          let finalData = {}
          // console.log(snapValue)
          jobID.map((data, idx) => {
            // console.log(data)
            finalData = {
              ...finalData,
              [data['requestID']]: {
                ...data,
                ...requestID[idx],
                ...checkWeight[data['requestID']],
                officerID: data['officerID']
              }
            }
          })
          Object.values(finalData).map((data) => {
            if (Number.isInteger(parseInt(data['officerID'])) && parseInt(data['officerID']) > 100) {
              let index = 0
              data['officerID'] = Object.values(viewAllOfficer).filter((o, idx) => {
                if (o['ID'] == parseInt(data['officerID'])) index = idx
                return o['ID'] == parseInt(data['officerID'])
              })[0]?.['fName']
              data['officerID'] = `${index + 1}. ${data['officerID']}`
            }
          })
          finalData = Object.values(finalData).sort((a, b) => parseInt(a['officerID']) - parseInt(b['officerID']))
          let officerData = {}
          finalData.map((data) => {
            if (!officerData[data['officerID']]) {
              officerData[data['officerID']] = {
                name: data['officerID'],
                officerID: parseInt(data['officerID']),
                totalWage: 0,
                totalPaid: 0,
                totalOT : 0,
                totalFare : 0,
              }
              officerDataFirstPart[data['officerID']] = {
                name: data['officerID'],
                officerID: parseInt(data['officerID']),
                totalWage: 0,
                totalPaid: 0,
                totalOT : 0,
                totalFare : 0,
              }
              officerDataSecondPart[data['officerID']] = {
                name: data['officerID'],
                officerID: parseInt(data['officerID']),
                totalWage: 0,
                totalPaid: 0,
                totalOT : 0,
                totalFare : 0,
              }
            }
            officerData[data['officerID']] = {
              ...officerData[data['officerID']],
              totalWage: officerData[data['officerID']]['totalWage'] + 1
            }
          })
          console.log(viewAllWageSheetByDate)
          Object.values(viewAllWageSheetByDate).map((jobData) => {
            if (jobData) {
              let isFoundJob = Object.values(officerData).filter(o => o['name'] == jobData['officerID'])
              // console.log(isFoundJob)
              if (isFoundJob.length > 0) {
                officerData[isFoundJob[0]['name']]['totalPaid'] += parseFloat(jobData['wageBaht'])
                officerData[isFoundJob[0]['name']]['totalOT'] += parseFloat(jobData['extraWage'])
                officerData[isFoundJob[0]['name']]['totalFare'] += parseFloat(jobData['transportFare'])
                if(jobData['shippingDate'].split('-')[1] == startDate.split('-')[1]){
                  officerDataFirstPart[isFoundJob[0]['name']]['totalPaid'] += parseFloat(jobData['wageBaht'])
                  officerDataFirstPart[isFoundJob[0]['name']]['totalOT'] += parseFloat(jobData['extraWage'])
                  officerDataFirstPart[isFoundJob[0]['name']]['totalFare'] += parseFloat(jobData['transportFare'])
                  officerDataFirstPart[isFoundJob[0]['name']]['totalWage'] += 1
                }
                if(jobData['shippingDate'].split('-')[1] == endDate.split('-')[1]){
                  officerDataSecondPart[isFoundJob[0]['name']]['totalPaid'] += parseFloat(jobData['wageBaht'])
                  officerDataSecondPart[isFoundJob[0]['name']]['totalOT'] += parseFloat(jobData['extraWage'])
                  officerDataSecondPart[isFoundJob[0]['name']]['totalFare'] += parseFloat(jobData['transportFare'])
                  officerDataSecondPart[isFoundJob[0]['name']]['totalWage'] += 1
                }
              }
            }
          })
          console.log(officerDataFirstPart)
          console.log(officerDataSecondPart)
          console.log(officerData)
          let sumData = {
            'totalPaid': 0,
            'totalWage': 0,
            'totalOT' : 0,
            'totalFare' : 0,
            'firstTotalPaid' : 0,
            'firstTotalOT' : 0,
            'firstTotalFare' : 0,
            'firstTotalWage' : 0,
            'secondTotalPaid' : 0,
            'secondTotalWage' : 0,
            'secondTotalOT' :0,
            'secondTotalFare' : 0,
          }
          Object.values(officerData).map((singleData) => {
            sumData['totalPaid'] += singleData['totalPaid']
            sumData['totalWage'] += singleData['totalWage']
            sumData['totalOT'] += singleData['totalOT']
            sumData['totalFare'] += singleData['totalFare']
          })
          Object.values(officerDataFirstPart).map((singleData) => {
            sumData['firstTotalPaid'] += singleData['totalPaid']
            sumData['firstTotalWage'] += singleData['totalWage']
            sumData['firstTotalOT'] += singleData['totalOT']
            sumData['firstTotalFare'] += singleData['totalFare']
          })
          Object.values(officerDataSecondPart).map((singleData) => {
            sumData['secondTotalPaid'] += singleData['totalPaid']
            sumData['secondTotalWage'] += singleData['totalWage']
            sumData['secondTotalOT'] += singleData['totalOT']
            sumData['secondTotalFare'] += singleData['totalFare']
          })

          this.setState({
            ...this.state,
            data: officerData,
            inCompleteLoading: false,
            sumData: sumData,
            officerDataFirstPart : officerDataFirstPart,
            officerDataSecondPart : officerDataSecondPart,
          })
        })
      })
  }
  handleTableClick = (e, idx, jobID) => {
    if (e.target.parentElement.id) {
      let prepData = [this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['description'][idx]]
      // let newData = this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]
      // newData['description'] = prepData
      this.props.history.push({
        pathname: '/ValidateCheckWeight',
        state: this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id],
        companyNameEN: this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['companyEN'],
        rawData: this.state.rawData,
        pageIndex: idx,
        itemIndex: jobID
      })

      // console.log(this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['description'])
      // this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id]['description'][0]['licenseID'] = license 
      // console.log(this.state.CheckWeightSheet)

    }

  }
  renderQuantity(data, idx) {
    console.log(data['description'][idx])
    if (data['description'][idx]['quantity']) {
      return (data['description'][idx]['quantity'] / 1000).toFixed(4)
    } else if (data['description'][idx]['Quantity']) {
      return (data['description'][idx]['Quantity'] / 1000).toFixed(4)
    } else {
      return null
    }
  }
  searchJob(e) {
    let jobID = parseInt(e.target.value)
    let SurveyData = this.state.rawData
    if (jobID > 0) {
      let arr = Object.values(SurveyData).filter((d) => {

        return d['jobID'].indexOf(jobID) != -1
      })
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: arr,
      })
    } else {
      this.setState({
        ...this.state,
        viewAllSurveyRequestSheetByDate: SurveyData
      })
      // console.log(SurveyData)
    }
  }
  render() {
    if (!this.state.inCompleteLoading) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <div style={{ width: '100%', alignContent: 'center', textAlign: 'center', fontSize: '22px' }}  >
            <p><b>ค่าแรง ประจำวันที่ {this.props.history.location.state.startDate}</b></p>
          </div>
          <Table bordered hover style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '11px' }}>ลำดับที่</th>
                <th style={{ width: '4.7%', overflow: 'auto', fontSize: '11px' }}>รายชื่อเช็คเกอร์</th>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '11px' }}>แรง งวด 1</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>ค่าแรงเฉลี่ย งวด 1</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>แรง งวด 2</th>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '11px' }}>ค่าแรงเฉลี่ย งวด 2</th>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '11px' }}>แรง</th>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '11px' }}>ค่าแรงเฉลี่ย</th>
                <th style={{ width: '2.7%', overflow: 'auto', fontSize: '11px' }}>ประกันสังคม</th>
              </tr>
            </thead>
            <tbody style={{ width: '100%' }}>
              {(() => {
                if (Object.values(this.state.data).length > 0) {
                  return (Object.values(this.state.data).map((data, idx) => {
                    // console.log(data['Time'] != undefined ? data['Time'].split('-')[1] : "")
                    let individualWage = (this.state.sumData['totalPaid']/this.state.sumData['totalWage']) * data['totalWage']
                    console.log(this.state.sumData)
                    let individualWageFirst = (this.state.sumData['firstTotalPaid'] /  this.state.sumData['firstTotalWage']) * Object.values(this.state.officerDataFirstPart)[idx]['totalWage']
                    let individualWageSecond = (this.state.sumData['secondTotalPaid'] /  this.state.sumData['secondTotalWage']) * Object.values(this.state.officerDataSecondPart)[idx]['totalWage']

                    return (<tr >
                      <td style={{ width: '7.7%', fontSize: '13px' }}><b>{data['officerID']}</b></td>
                      <td style={{ width: '2.7%', fontSize: '13px', textAlign: 'left' }}><b>{data['name']}</b></td>
                      <td style={{ width: '7.7%', fontSize: '13px' }}><b>{Object.values(this.state.officerDataFirstPart)[idx]['totalWage']}</b></td>
                      <td style={{ width: '2.7', overflow: 'auto', fontSize: '13px' }}><b>{addCommaInNumber(individualWageFirst.toFixed(2))}</b></td>
                      <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{Object.values(this.state.officerDataSecondPart)[idx]['totalWage']}</b></td>
                      <td style={{ width: '2.7%', overflow: '2.7%', fontSize: '13px' }}><b>{addCommaInNumber(individualWageSecond.toFixed(2))}</b></td>
                      <td style={{ width: '2.7%', fontSize: '13px' }}>{(data['totalWage'])}</td>
                      <td style={{ width: '2.7%', fontSize: '13px' }}>{addCommaInNumber((individualWage+data['totalOT']).toFixed(2))}</td>
                      <td style={{ width: '2.7%', fontSize: '13px' }}>{parseInt(((individualWage+data['totalOT'])* 0.05)).toFixed(2)}</td>
                    </tr>)
                  }))
                }
              })()}
              {(() => {
                if(this.state.sumData){
                  return (<tr >
                    <td style={{ width: '7.7%', fontSize: '13px' }}><b>{}</b></td>
                    <td style={{ width: '2.7%', fontSize: '13px', textAlign: 'left' }}><b>{}</b></td>
                    <td style={{ width: '7.7%', fontSize: '13px' }}><b>{this.state.sumData['firstTotalWage'].toFixed(2)}</b></td>
                    <td style={{ width: '2.7', overflow: 'auto', fontSize: '13px' }}><b>{ this.state.sumData['firstTotalPaid'].toFixed(2)}</b></td>
                    <td style={{ width: '2.7%', overflow: 'auto', fontSize: '13px' }}><b>{this.state.sumData['secondTotalWage'].toFixed(2)}</b></td>
                    <td style={{ width: '2.7%', overflow: '2.7%', fontSize: '13px' }}><b>{this.state.sumData['secondTotalPaid'].toFixed(2)}</b></td>
                    <td style={{ width: '2.7%', fontSize: '13px' }}>{this.state.sumData['totalWage'].toFixed(2)}</td>
                    <td style={{ width: '2.7%', fontSize: '13px' }}>{this.state.sumData['totalPaid'].toFixed(2)}</td>
                    <td style={{ width: '2.7%', fontSize: '13px' }}></td>
                  </tr>)
  
                }
              })()}

            </tbody>
          </Table>
        </Container>
      )
    }
    else {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading />
      </Container>)
    }
  }
}


export default withRouter(FinancialWageMonthlyTable);
